import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading } from '@wix/design-system';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './base44GateHeader.scss';
export const Base44GateHeader = _ref => {
  let {
    onBackClick,
    ...props
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const {
    siteName
  } = getPremiumEssentialsSafe() ?? {
    siteName: 'your app'
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    align: "center",
    width: "100%",
    gap: "SP8"
  }, props), /*#__PURE__*/React.createElement(HeaderWrapper, {
    onBackClick: onBackClick
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: s.siteGateHeaderTitle
  }, t('domains_search_gate.base44.gate.title', {
    appName: siteName
  }))));
};
//# sourceMappingURL=Base44GateHeader.js.map